(() => {
  const init = () => {
    const body = document.body;
    const section = document.querySelector('.section-header');
    const header = section?.querySelector('.header-wrapper');
    if (!body.classList.contains('frm-video-home') || !header) return;
    const measure = () => body.style.setProperty('--frm-overlay-header-height', `${header.getBoundingClientRect().height}px`);
    const update = () => body.classList.toggle('frm-header-solid', window.scrollY > 20 || Boolean(header.querySelector('details[open]')));
    measure();
    update();
    new ResizeObserver(measure).observe(header);
    window.addEventListener('scroll', update, { passive: true });
    header.addEventListener('toggle', update, true);
    window.addEventListener('pageshow', update);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
